var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./Comment.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-77a4aede!../node_modules/vue-loader/lib/selector?type=template&index=0!./Comment.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/Comment.vue
// module id = 20
// module chunks = 0